import './onboarding.scss'
import React, { Fragment, useState, useEffect } from 'react';
import { __ } from "@wordpress/i18n";
import { nxtInstallCall, appendFormData, nxtdash_fetch_api } from '../../apicall';
import { Wkit_template_Skeleton } from './../templates/skeleton.js';
import { useNavigate } from 'react-router-dom';
import './../templates/templates.scss';
import { nxtdash_save_data } from '../../apicall';

const EnableTemplate = ({ onBoardingStep, setOnBoardingStep, reload }) => {
    const [templates, setTemplates] = useState(nxtext_ajax_object.dashData.wdTemplates);
    const [isFetching, setIsFetching] = useState(false);
    const [isTemplatesEnabled, setIsTemplatesEnabled] = useState(nxtext_ajax_object.dashData.wdadded);

    const Navigate = useNavigate();
    useEffect(() => {
        const fetchTemplates = async () => {
            setIsFetching(true);
            
            try {
                var api_body = {
                    ParPage: 9,
                    CurrentPage: 1,
                    builder_req: 1002,
                    temp_type_req: 'all',
                    freepro_req: 'all'
                };

                var wdk_api = nxtext_ajax_object.dashData.nxt_wdkit_url;
                var api_url = wdk_api + 'api/front/getfilterbrowsetemplates';
                var nonce = nxtext_ajax_object.ajax_nonce;
                var ajax_url = nxtext_ajax_object.ajax_url;

                let form = new FormData();
                form.append('action', 'nexter_temp_api_call');
                form.append('nexter_nonce', nonce);
                form.append('method', 'POST');
                form.append('api_url', api_url);
                form.append('url_body', JSON.stringify(api_body));

                var response = await fetch(ajax_url, {
                    method: 'POST',
                    body: form
                });
                
                var data = await response.json();
                
                if (data.HTTP_CODE === 200 && data.posts) {
                    nxtext_ajax_object.dashData.wdTemplates = data.posts;
                    setTemplates(data.posts);
                    setTimeout(() => {
                        setIsFetching(false);
                    }, 800);
                } else {
                    setIsFetching(false);
                }
            } catch (error) {
                console.error('Error fetching templates:', error);
                setIsFetching(false);
            }
        };

        if (templates.length === 0 && !isFetching) {
            fetchTemplates();
        }
    }, [templates.length, isFetching]);

    useEffect(() => {
        if ((nxtext_ajax_object.pro || nxtext_ajax_object.tpgb_pro) && nxtext_ajax_object.dashData.whiteLabel?.nxt_template_tab == 'on') {
            Navigate('/');
        }
    }, [nxtext_ajax_object.dashData.whiteLabel?.nxt_template_tab]);


    return (
        <>
            <div className="nxt-board-enbls-temp nxt-board-onbsec-cover">
                <div className="nxt-board-sech-btn">
                    <h2 className="nxt_section_heading">{__('Get 1000+ Pre-Designed WordPress Websites & Templates', 'nexter-extension')}</h2>
                    {/* <div className='nxt_header_toggle_btn_group'>
                        {!isTemplatesEnabled ?
                            <button onClick={(e) => wdinstallCall(e, reload, setIsTemplatesEnabled)} className='nxt_blue_common_btn'>{__('Enable Templates', 'nexter-extension')}</button>
                            :
                            <a href='?page=wdesign-kit#/browse' target="_blank" rel="noopener noreferrer" className='nxt_blue_common_btn'>{__('Open Templates', 'nexter-extension')} </a>
                        }
                    </div> */}
                </div>
                <div className="nxt-board-templ-cover nxt-board-whitebg-cover">

                    {templates.length > 0 ? templates.map((template) => (
                        <div className="nxt-board-wtempl-card" onClick={() => window.open(template.post_url, '_blank')}>
                            <div className="nxt-board-temimg-cover">
                                <img className="nxt-board-wtemp-img" src={template.image_url} draggable={false} />
                            </div>
                            <h4 className="nxt-board-in-sec-heading">{template.title}</h4>
                        </div>
                    )) : <Wkit_template_Skeleton count={8} />}
                </div>

                <div className="nxt-board-btmsm-btn">
                    <span className="nxt-board-link-btn" onClick={() => { setOnBoardingStep(onBoardingStep - 1) }}>{__('Back', 'nexter-extension')}</span>

                    <div className="nxt-board-rit-btn-cover">
                        <span className="nxt-board-link-btn" onClick={() => { setOnBoardingStep(onBoardingStep + 1) }}>{__('Skip', 'nexter-extension')}</span>
                        {!isTemplatesEnabled ?
                            <button onClick={(e) => nxtInstallCall(e, reload, 'wdesignkit', setIsTemplatesEnabled)} className='nxt_blue_common_btn'>{__('Enable Templates', 'nexter-extension')}</button>
                            :
                            <span className="nxt_blue_common_btn" onClick={() => { setOnBoardingStep(onBoardingStep + 1) }}>{__('Continue', 'nexter-extension')}</span>
                        }
                    </div>
                </div>
            </div>
        </>

    );
}

const Onboarding = ({ setIsPopupVisible, onComplete = () => { } } , setIsPopupType, isPopupType, setIsOnboardingVisible) => {

    const [onBoardingStep, setOnBoardingStep] = useState(() => {
        const savedStep = localStorage.getItem('onBoardingStep');
        return savedStep ? parseInt(savedStep) : 1;
    });

    const [nextstep, setNextstep] = useState(() => {
        const savedNextStep = localStorage.getItem('onBoardingNextStep');
        return savedNextStep || null;
    });

    useEffect(() => {
        localStorage.setItem('onBoardingStep', onBoardingStep.toString());
        localStorage.setItem('onBoardingNextStep', nextstep);
    }, [onBoardingStep, nextstep]);

    const [activeIndex, setActiveIndex] = useState(0);
    const [categoryToggles, setCategoryToggles] = useState({});
    const [selectedBlocks, setSelectedBlocks] = useState(() => {
        const enableBlock = nxtext_ajax_object.dashData.enableBlock || [];
        const blockList = nxtext_ajax_object.dashData.blockList || {};

        const initialSelectedBlocks = {};
        Object.entries(blockList).forEach(([slug, data]) => {
            if (data && data.label) {
                initialSelectedBlocks[data.label] = enableBlock.includes(slug);
            }
        });

        return initialSelectedBlocks;
    });
    const [setupStarted, setSetupStarted] = useState(false);

    const [currentStep, setCurrentStep] = useState(0);
    const [stepsComplete, setStepsComplete] = useState([false, false, false]);
    const [reload, setReload] = useState(false);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [loading, setLoading] = useState(false);
    const [userEmail, setUserEmail] = useState(nxtext_ajax_object.dashData.userData.userEmail);


    useEffect(() => {
        const shouldTrigger = sessionStorage.getItem('triggerOnComplete');
        if (shouldTrigger === 'yes') {
            sessionStorage.removeItem('triggerOnComplete');
            onComplete();
        }
    }, [onComplete]);

    const data_save = async () => {

        const blocks_used = nxtext_ajax_object.dashData.enableBlock;

        const tpgbonData = {
            tpgb_onboarding : isChecked,
            blocks_used: blocks_used,
        };

        let form = new FormData();
        const formData = {
            action: 'nxt_boarding_store',
            boardingData: JSON.stringify(tpgbonData),
            security: nxtext_ajax_object.ajax_nonce,
        };
        appendFormData(form, formData);

        try {
            const response = await nxtdash_fetch_api(form);
            const data = await response

            console.log('Response from server:', data);

            if (data && data.onBoarding) {
                sessionStorage.setItem('triggerOnComplete', 'yes');
                
                if(nxtext_ajax_object.dashData.showSidebar === true){
                    sessionStorage.setItem('showSidebar', true);
                }

                window.location.reload();
            }

        } catch (error) {
            console.error('Error scanning unused blocks:', error);
        }

    };
    const nav_array = () => {
        if ('' === nextstep || 'nxt_blocks' === nextstep) {
            const steps = [
                { step_number: 1, step_name: __('Select Mode', 'nexter-extension') },
                { step_number: 2, step_name: __('Select Blocks', 'nexter-extension') },
                { step_number: 3, step_name: __('Enable Template', 'nexter-extension') },
                { step_number: 4, step_name: __('Theme Builder', 'nexter-extension') },
            ];

            if (!nxtext_ajax_object.pro) {
                steps.push({ step_number: 5, step_name: __('Special Offer', 'nexter-extension') });
            }

            steps.push(
                { step_number: 6, step_name: __('Stay Updated', 'nexter-extension') },
                { step_number: 7, step_name: __('Confirmation', 'nexter-extension') },
            );

            return steps;
        }
        else if ('import_web' === nextstep) {
            return [
                { step_number: 1, step_name: __('Select Mode', 'nexter-extension') },
                { step_number: 2, step_name: __('Select Template', 'nexter-extension') },
            ];
        }
    };

    const loading_animation = () => {
        setSetupStarted(true);

        // Step 1
        setCurrentStep(1);

        // Step 1 complete -> Step 2
        setTimeout(() => {
            setStepsComplete(prev => [true, false, false]);
            setCurrentStep(2);

            // Step 2 complete -> Step 3
            setTimeout(() => {
                setStepsComplete(prev => [true, true, false]);
                setCurrentStep(3);

                // Final Step complete
                setTimeout(() => {
                    setStepsComplete(prev => [true, true, true]);
                    setCurrentStep(0);
                }, 1500);

            }, 2000);

        }, 1500);
    };

    const select_mode = () => {

        const handleSelect = async (e) => {
            loading_animation();
            setOnBoardingStep(onBoardingStep + 1);
            if ('import_web' === nextstep) {
                if (nxtext_ajax_object.dashData.wdadded) {
                    await  data_save();

                    if(nxtext_ajax_object.pro){
                        window.location.href ='?page=wdesign-kit#/browse?builder=1002&plugin=[1007,1008]&free_pro=pro';
                    }else{
                        window.location.href ='?page=wdesign-kit#/browse?builder=1002&plugin=[1007]&free_pro=free';
                    }
                } else {
                    nxtInstallCall(e, reload, 'wdesignkit');
                }
            }
        };

        const handleSelection = (selection) => {

            localStorage.setItem('onBoardingNextStep', selection);
            setNextstep(selection);
        };

        return (
            <div className="nxt-board-start-crd-main nxt-board-onbsec-cover">
                <svg xmlns="http://www.w3.org/2000/svg" width="104" height="32" fill="none"><path fill="#1717CC" fill-rule="evenodd" d="M53.676 19.997c.273-.128.41-.304.41-.531V0h3.5v19.533c0 1.094-.666 1.96-1.996 2.596l-.627.299.627.298c1.331.64 1.997 1.504 1.997 2.593v6.593h-3.511v-6.508c0-.241-.137-.427-.41-.555L51.46 24l-2.207.849c-.272.128-.409.314-.409.555v6.507H45.34v-6.594c0-1.09.666-1.955 1.996-2.593l.627-.299-.627-.298c-1.33-.638-1.996-1.503-1.996-2.597V0l3.495.013V19.48c0 .228.135.408.41.532l2.215.84 2.217-.855ZM18.813.09l5.22 11.249V.089h3.499V32h-3.498l-.007-14.946L18.813 5.81V32h-3.498V.09h3.498Zm42.615 2.724 4.213-.002V32h3.488l.014-29.188h4.206V.09H61.432l-.004 2.724Zm41.63 20.2c0 1.333-.739 2.247-2.217 2.745 1.481.509 2.23 1.433 2.238 2.768v3.455h-3.501l.016-3.539a1.522 1.522 0 0 0-.123-.592l-.015-.026a1.131 1.131 0 0 0-.54-.508l-.036-.016a1.541 1.541 0 0 0-.133-.055 1.717 1.717 0 0 0-.468-.113l-.006-.001-.007-.002a.207.207 0 0 0-.05-.008H94.65v4.86h-3.5V.066h8.419c1.037 0 1.599.298 2.353.885.754.588 1.135 1.293 1.135 2.116v19.947Zm-3.61.691a.994.994 0 0 0 .122-.457l.004-19.798a.54.54 0 0 0-.246-.456.933.933 0 0 0-.573-.182h-4.109v21.585h3.423c.382.01.757-.11 1.062-.341a1 1 0 0 0 .317-.35ZM31.38 31.997h10.113V29.27h-6.605v-5.466h4.68v-2.726h-4.68V2.811h6.605V.086H31.38v31.911Zm52.425-29.18-6.61-.003V.09h10.117V32H77.196v-2.724H83.8V12.673h-4.677V9.945h4.68V2.818ZM6.17 28.17l-.017 3.632H.92v-5.046h3.786a.19.19 0 0 1 .053.01.226.226 0 0 0 .033.007c.162.017.321.057.473.117.048.016.095.037.14.056l.003.002.01.006.009.004.018.011c.247.11.45.3.572.54l.013.022.004.007a1.067 1.067 0 0 1 .086.258c.032.122.05.248.05.374Zm-.017-5.57V1.362a.585.585 0 0 0-.258-.49.984.984 0 0 0-.61-.197H.92v23.154h3.638c.408.014.808-.115 1.131-.364.313-.247.465-.534.465-.865Z" clip-rule="evenodd" /></svg>
                <h2 className="nxt_section_heading">{__('How would you like to start?', 'nexter-extension')}</h2>

                <div className="nxt-board-strt-crd-cover nxt-board-whitebg-cover">
                    <div className={`nxt-board-strat-card ${'import_web' === nextstep ? 'nxt-board-active-board-card' : ''} `} onClick={() => { handleSelection('import_web') }}>
                        <div className="nxt-board-icon-box">
                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 40 40"><rect width="39.385" height="39.385" x=".308" y=".308" fill="#F5F7FE" rx="3.264" /><rect width="39.385" height="39.385" x=".308" y=".308" stroke="#E2E9FF" strokeWidth=".615" rx="3.264" /><path fill="#1717CC" fill-rule="evenodd" d="M12.5 12a.5.5 0 0 0-.5.5v3h16v-3a.5.5 0 0 0-.5-.5h-15Zm3 5.5H12v10a.5.5 0 0 0 .5.5h3V17.5Zm2 10.5V17.5H28v10a.5.5 0 0 1-.5.5h-10Zm-1 2h-4a2.5 2.5 0 0 1-2.5-2.5v-15a2.5 2.5 0 0 1 2.5-2.5h15a2.5 2.5 0 0 1 2.5 2.5v15a2.5 2.5 0 0 1-2.5 2.5h-11Z" clip-rule="evenodd" /></svg>
                        </div>
                        <div>
                            <h3 className="nxt-board-crd-h">{__('Import Ready Made Website', 'nexter-extension')}</h3>
                            <p className="tpar-crd-desc">{__('Get a Full Website Ready Under 60 seconds', 'nexter-extension')}</p>
                        </div>
                        <div className="nxt-board-info-icon">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.0013 2.0013C4.68759 2.0013 2.0013 4.68759 2.0013 8.0013C2.0013 11.315 4.68759 14.0013 8.0013 14.0013C11.315 14.0013 14.0013 11.315 14.0013 8.0013C14.0013 4.68759 11.315 2.0013 8.0013 2.0013ZM0.667969 8.0013C0.667969 3.95121 3.95121 0.667969 8.0013 0.667969C12.0514 0.667969 15.3346 3.95121 15.3346 8.0013C15.3346 12.0514 12.0514 15.3346 8.0013 15.3346C3.95121 15.3346 0.667969 12.0514 0.667969 8.0013ZM7.33477 5.33464C7.33477 4.96645 7.63324 4.66797 8.00143 4.66797H8.0081C8.37629 4.66797 8.67477 4.96645 8.67477 5.33464C8.67477 5.70283 8.37629 6.0013 8.0081 6.0013H8.00143C7.63324 6.0013 7.33477 5.70283 7.33477 5.33464ZM8.00143 7.33477C8.36962 7.33477 8.6681 7.63324 8.6681 8.00143V10.6681C8.6681 11.0363 8.36962 11.3348 8.00143 11.3348C7.63324 11.3348 7.33477 11.0363 7.33477 10.6681V8.00143C7.33477 7.63324 7.63324 7.33477 8.00143 7.33477Z" fill="#727272" />
                            </svg>
                            <span className="nxt-board-tip-txt">{__('This will install the WDesignKit Plugin, which enables you to import WordPress Website Templates & Sections.', 'nexter-extension')}</span>
                        </div>
                    </div>

                    <div className={`nxt-board-strat-card ${'nxt_blocks' === nextstep ? 'nxt-board-active-board-card' : ''}`} onClick={() => { handleSelection('nxt_blocks') }}>
                        <div className="nxt-board-icon-box">
                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 40 40"><rect width="39.385" height="39.385" x=".308" y=".308" fill="#F5F7FE" rx="3.264" /><rect width="39.385" height="39.385" x=".308" y=".308" stroke="#E2E9FF" strokeWidth=".615" rx="3.264" /><path fill="#1717CC" fill-rule="evenodd" d="M12 10a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2h-5Zm0 2h5v5h-5v-5Zm0 9a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2h-5Zm0 2h5v5h-5v-5Zm9-11a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2v-5Zm7 0h-5v5h5v-5Zm-5 9a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2h-5Zm0 2h5v5h-5v-5Z" clip-rule="evenodd" /></svg>
                        </div>
                        <div>
                            <h3 className="nxt-board-crd-h">{__('Use WordPress Blocks', 'nexter-extension')}</h3>
                            <p className="tpar-crd-desc">{__('Create your design with our highly customisable Blocks', 'nexter-extension')}</p>
                        </div>
                    </div>
                </div>

                <button className={`nxt_blue_common_btn ${nextstep ? '' : 'nxt-board-disable-element'}`} onClick={handleSelect} disabled={nextstep ? false : true}>{__('Continue', 'nexter-extension')}</button>
            </div>
        )
    }

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                setIsPopupVisible(false);
            }
        };

        const handleOutsideClick = (event) => {
            if (!event.target.closest('.nxt_whitlabel_popup.nxt_blist')) {
                setIsPopupVisible(false);
            }
        };

        document.addEventListener("keydown", handleKeyDown);
        document.addEventListener("mousedown", handleOutsideClick);

        return () => {
            document.removeEventListener("keydown", handleKeyDown);
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, [setIsPopupVisible]);

    useEffect(() => {
        const blockCate = ['Essential', 'Creative', 'Tabbed', 'Social', 'Advanced', 'Listing', 'Builder', 'Extras'];
        const blockList = nxtext_ajax_object.dashData.blockList || {};
        const blockListValue = Object.values(blockList);
    
        const initialToggles = blockCate.reduce((acc, category) => {
            const eligibleBlocks = blockListValue.filter(
                block => block?.block_cate === category && (block.tag !== 'pro' || nxtext_ajax_object.pro)
            );
            acc[category] = eligibleBlocks.length > 0 && eligibleBlocks.every(block => selectedBlocks[block.label]);
            return acc;
        }, {});
    
        setCategoryToggles(initialToggles);
    }, []);

    const select_blockCate = () => {

        const blockCate = ['Essential', 'Creative', 'Tabbed', 'Social', 'Advanced', 'Listing', 'Builder', 'Extras'];

        let blockList = nxtext_ajax_object.dashData.blockList || {};
        let blockListValue = Object.values(blockList);

        const categorizedBlocks = {};
        blockCate.forEach(cate => {
            categorizedBlocks[cate] = blockListValue.filter(item => item?.block_cate === cate);
        });

        const handleSaveBlock = async (e) => {
            const allSelectedBlocks = Object.entries(blockList).filter(([slug, data]) => {
            // Exclude if pro is disabled and block has pro tag
            if (!nxtext_ajax_object.pro && data.tag === 'pro') {
                return false;
            }
            return selectedBlocks[data.label];
        }).map(([slug]) => slug);

            const tpBlocks = allSelectedBlocks.filter(slug => slug.startsWith('tp-'));

            nxtext_ajax_object.dashData.enableBlock = tpBlocks;

            await nxtdash_save_data(e, {
                action: 'tpgb_blocks_opts_save',
                'submit-key': 'Save',
                'enable_normal_blocks': JSON.stringify(tpBlocks),
                'tp_extra_option': JSON.stringify([]),
                'nonce_tpgb_normal_blocks_opts': nxtext_ajax_object.ajax_nonce || nxtext_ajax_object.nonce,
            });

            setTimeout(() => {
                setOnBoardingStep(onBoardingStep + 1);
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }, 1000);
        };

        const WDKActivation = () => {
            setTimeout(async() => {
                localStorage.removeItem('onBoardingStep');
                localStorage.removeItem('onBoardingNextStep');
                await data_save();
                if(nxtext_ajax_object.pro){
                    window.location.href = '?page=wdesign-kit#/browse?builder=1002&plugin=[1007,1008]&free_pro=pro';
                }else{
                    window.location.href = '?page=wdesign-kit#/browse?builder=1002&plugin=[1007]&free_pro=free';
                }
            }, 5000);
        };

        const handleToggleChange = (cate) => {
            const newToggleState = !categoryToggles[cate];
            setCategoryToggles(prev => ({
                ...prev,
                [cate]: newToggleState
            }));

            const updatedSelectedBlocks = { ...selectedBlocks };
            if (!newToggleState) {
                categorizedBlocks[cate]?.forEach(block => {
                    updatedSelectedBlocks[block.label] = false;
                });
            }
            else {
                categorizedBlocks[cate]?.forEach(block => {
                    if (block.tag !== 'pro' || nxtext_ajax_object.pro) {
                        updatedSelectedBlocks[block.label] = true;
                    }
                });
            }

            setSelectedBlocks(updatedSelectedBlocks);
        };

        	
        const updateCategoryToggle = (category, updatedBlocks) => {
            const blocksInCategory = categorizedBlocks[category] || [];
            const eligibleBlocks = blocksInCategory.filter(block =>
                block.tag !== 'pro' || nxtext_ajax_object.pro
            );
            const allSelected = eligibleBlocks.length > 0 && eligibleBlocks.every(block =>
                updatedBlocks[block.label]
            );
            setCategoryToggles(prev => ({
                ...prev,
                [category]: allSelected
            }));
        };
        const findBlockCategory = (blockLabel) => {
            return Object.keys(categorizedBlocks).find(category =>
                categorizedBlocks[category]?.some(block => block.label === blockLabel)
            );
        };

        const green_chek = <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><path fill="#14C38E" d="M6.95 9.35 5.338 7.738a.711.711 0 0 0-.526-.207.711.711 0 0 0-.525.207.711.711 0 0 0-.206.524c0 .213.069.388.206.525l2.138 2.138a.72.72 0 0 0 .525.225.72.72 0 0 0 .525-.225l4.238-4.238a.711.711 0 0 0 .206-.525.711.711 0 0 0-.207-.524.711.711 0 0 0-.524-.207.711.711 0 0 0-.526.207L6.95 9.35ZM8 15.5a7.3 7.3 0 0 1-2.925-.591 7.585 7.585 0 0 1-2.381-1.603 7.558 7.558 0 0 1-1.603-2.381A7.32 7.32 0 0 1 .5 8c0-1.037.197-2.012.591-2.925a7.591 7.591 0 0 1 1.603-2.381A7.563 7.563 0 0 1 5.075 1.09 7.306 7.306 0 0 1 8 .5c1.037 0 2.011.197 2.925.591a7.563 7.563 0 0 1 2.381 1.603 7.602 7.602 0 0 1 1.604 2.381A7.26 7.26 0 0 1 15.5 8a7.354 7.354 0 0 1-.591 2.925 7.524 7.524 0 0 1-1.603 2.381 7.619 7.619 0 0 1-2.381 1.604A7.266 7.266 0 0 1 8 15.5Z" /></svg>;

        const gray_check = <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><path fill="#D9D9D9" d="M6.95 9.35 5.338 7.738a.711.711 0 0 0-.526-.207.711.711 0 0 0-.525.207.711.711 0 0 0-.206.524c0 .213.069.388.206.525l2.138 2.138a.72.72 0 0 0 .525.225.72.72 0 0 0 .525-.225l4.238-4.238a.711.711 0 0 0 .206-.525.711.711 0 0 0-.207-.524.711.711 0 0 0-.524-.207.711.711 0 0 0-.526.207L6.95 9.35ZM8 15.5a7.3 7.3 0 0 1-2.925-.591 7.585 7.585 0 0 1-2.381-1.603 7.558 7.558 0 0 1-1.603-2.381A7.32 7.32 0 0 1 .5 8c0-1.037.197-2.012.591-2.925a7.591 7.591 0 0 1 1.603-2.381A7.563 7.563 0 0 1 5.075 1.09 7.306 7.306 0 0 1 8 .5c1.037 0 2.011.197 2.925.591a7.563 7.563 0 0 1 2.381 1.603 7.602 7.602 0 0 1 1.604 2.381A7.26 7.26 0 0 1 15.5 8a7.354 7.354 0 0 1-.591 2.925 7.524 7.524 0 0 1-1.603 2.381 7.619 7.619 0 0 1-2.381 1.604A7.266 7.266 0 0 1 8 15.5Z" /></svg>;

        const progress_indi = <div className="loader nxt-board-progress-indi"></div>;

        return (
            <>
                {'nxt_blocks' === nextstep &&
                    <div className="nxt-board-select-wid-temp nxt-board-onbsec-cover nxt-board-seltemp nxt-board-selwidgets">
                        <div className="nxt-board-select-wid-cover nxt-board-onbsec-cover">
                            <h2 className="nxt_section_heading">{__('Select the Blocks You Want to Use', 'nexter-extension')}</h2>

                            <div className="nxt-board-widget-checklist">
                                <div className="nxt-board-wid-checklist-main">
                                    {blockCate.map((cate, index) => (
                                        <div key={index}>
                                            <div className="nxt-board-widlist-name-with-toggle">
                                                <div className="nxt-board-widlist-name">{cate}</div>
                                                <div className="nxt_block_inner_toggle">
                                                    <div className="nxt_block_toggle_btn_cover">
                                                        <input className="nxt_toggle_btn" type="checkbox" id={`toggle-${cate}`} checked={categoryToggles[cate]} onChange={() => handleToggleChange(cate)} />
                                                        <label className="switch-label" htmlFor={`toggle-${cate}`}>
                                                            <span className="switch-button"></span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="nxt-board-check-widlist">
                                                {categorizedBlocks[cate]?.map((cb_data, i) => {
                                                    const isPro = cb_data?.tag === 'pro';

                                                    const isProActive = nxtext_ajax_object.pro;
                                                    const modifiedUrl = cb_data?.demoUrl.replace('nextersettings', 'nexterOnboarding')
                                                    return (
                                                        <div className="nxt-board-wid-list" key={i}>
                                                            {(isPro && !isProActive) ? (
                                                                <span className="nxt-board-lock-icon"  onClick={() => {  if (isPro && !isProActive) { setIsPopupVisible(true);}  }}> <svg xmlns="http://www.w3.org/2000/svg" width="10" height="14" fill="none" viewBox="0 0 10 10"><path fill="#fff" d="M8.313 5.25V3.81A2.94 2.94 0 0 0 5.377.876h-.254a2.94 2.94 0 0 0-2.936 2.936V5.25A1.313 1.313 0 0 0 .875 6.563v4.068a2.498 2.498 0 0 0 2.494 2.494H7.13a2.498 2.498 0 0 0 2.494-2.494V6.562A1.313 1.313 0 0 0 8.312 5.25Zm-5.25-1.44a2.06 2.06 0 0 1 2.06-2.06h.254a2.06 2.06 0 0 1 2.06 2.06v1.44H3.063V3.81Zm5.687 6.821a1.619 1.619 0 0 1-1.619 1.619H3.37a1.619 1.619 0 0 1-1.619-1.619V6.562a.437.437 0 0 1 .438-.437h6.124a.437.437 0 0 1 .438.438v4.068Z" /><path fill="#fff" d="M5.688 9.065V10.5a.437.437 0 1 1-.875 0V9.065a.875.875 0 1 1 .875 0Z" /></svg></span>
                                                            ) : (
                                                                <input
                                                                    type="checkbox"
                                                                    className="nxt-board-chkbox-style"
                                                                    id={cb_data.label}
                                                                    checked={!!selectedBlocks[cb_data.label]}
                                                                    onChange={(e) => {
                                                                        const checked = e.target.checked;
                                                                        const updatedBlocks = {
                                                                            ...selectedBlocks,
                                                                            [cb_data.label]: checked
                                                                        };

                                                                        setSelectedBlocks(updatedBlocks);

                                                                        const blockCategory = findBlockCategory(cb_data.label);
                                                                        if (blockCategory) {
                                                                            updateCategoryToggle(blockCategory, updatedBlocks);
                                                                        }
                                                                    }}
                                                                />
                                                            )}

                                                            <label className="nxt-board-wid-chk-name">
                                                                <a target="_blank" rel="noopener noreferrer" href={modifiedUrl? modifiedUrl : "#"} className="nxt_modified_url">
                                                                    {cb_data.label}
                                                                </a>
                                                            </label>
                                                            {isPro && <span className="nxt-board-fp-tag">{__('Pro', 'nexter-extension')}</span>}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    ))}

                                </div>
                            </div>
                        </div>
                        <div className="nxt-board-btmsm-btn">
                            <span className="nxt-board-link-btn" onClick={() => { setOnBoardingStep(onBoardingStep - 1) }}>{__('Back', 'nexter-extension')}</span>
                            <span className="nxt_blue_common_btn nxt-btn-fix" onClick={handleSaveBlock}>{__('Continue', 'nexter-extension')}</span>
                        </div>
                    </div>
                }

                {'import_web' === nextstep &&
                    <div className="nxt-board-select-wid-temp nxt-board-onbsec-cover nxt-board-seltemp nxt-board-selwidgets">
                        <div className="nxt-board-select-website nxt-board-onbsec-cover">
                            <h2 className="nxt-board-onbrd-crd-h">{__('Setting Up for Website Templates', 'nexter-extension')}</h2>
                            <div className="nxt-board-webtyp-btnver">
                                <div className="nxt-board-webtype-list nxt-board-whitebg-cover">
                                    <div className="nxt-board-steps-cover-vertical">
                                        {/* Step 1 */}
                                        <div className="nxt-board-webtylist-cover step">
                                            <div className="nxt-board-webtype">
                                                <span className='nxt-board-step-icon'>
                                                    {stepsComplete[0] ? (green_chek) : currentStep === 1 ? (progress_indi) : (gray_check)}
                                                </span>
                                                <span className={`nxt-board-step-text ${stepsComplete[0] ? 'step-complete' : currentStep === 1 ? 'step-current' : 'step-default'}`}>
                                                    {__('Enabling Website Templates', 'nexter-extension')}
                                                </span>
                                            </div>
                                        </div>

                                        {/* Step 2 */}
                                        <div className="nxt-board-webtylist-cover step">
                                            <div className="nxt-board-webtype">
                                                <span className='nxt-board-step-icon'>
                                                    {stepsComplete[1] ? (green_chek) : currentStep === 2 ? (progress_indi) : (gray_check)}
                                                </span>
                                                <span className={`nxt-board-step-text ${stepsComplete[1] ? 'step-complete' : currentStep === 2 ? 'step-current' : 'step-default'}`}>
                                                    {__('Installing WDesignKit', 'nexter-extension')}
                                                </span>
                                            </div>
                                        </div>

                                        {/* Step 3 */}
                                        <div className="nxt-board-webtylist-cover step">
                                            <div className="nxt-board-webtype">
                                                <span className='nxt-board-step-icon'>
                                                    {stepsComplete[2] ? (green_chek) : currentStep === 3 ? (progress_indi) : (gray_check)}
                                                </span>
                                                <span className={`nxt-board-step-text ${stepsComplete[2] ? 'step-complete' : currentStep === 3 ? 'step-current' : 'step-default'}`}>
                                                    {__('WDesignKit Activated', 'nexter-extension')}
                                                </span>
                                                {currentStep === 3 && WDKActivation()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </>

        )
    }

    const theme_builder = () => {

                const accordian_content = [
            { question: __('Why Do I Need a Theme Builder?', 'nexter-extension'), answer: __('Our Theme Builder gives you the capability to customize the <strong>Header, Footer, Single, and Archive Pages</strong> using Nexter’s <strong>dynamic blocks</strong>.<br><br>You don’t need to rely on the <strong>limited controls of the customizer</strong> like other themes. This makes the <strong>Nexter ecosystem truly limitless</strong>, allowing you to create every element with blocks.', 'nexter-extension') },
            { question: __('Will this work with any WordPress theme?', 'nexter-extension'), answer: __('Yes, the Nexter Extension works with <strong> any WordPress theme</strong>. That said, we <strong> highly recommend using it with the Nexter theme</strong> — it’s the <strong> lightest theme available</strong>, under <strong> 10KB</strong>, built with <strong> pure vanilla JavaScript and no jQuery</strong>. This ensures your website stays lightning fast and optimized. But don’t worry, you’re free to use any theme you like!', 'nexter-extension') },
            { question: __('Will it break my current website?', 'nexter-extension'), answer: __('Not at all! The Theme Builder is designed to <strong> integrate smoothly with your existing site</strong>. It won’t interfere with your current layout or content. You can activate and use it gradually, applying changes only when you’re ready.', 'nexter-extension') },
        ];

        const theme_accordian = (index) => {
            setActiveIndex(activeIndex === index ? null : index);

        };

        let clickSvg = <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><path fill="#1717CC" d="M6.95 9.35 5.338 7.738a.711.711 0 0 0-.526-.207.711.711 0 0 0-.525.207.711.711 0 0 0-.206.524c0 .213.069.388.206.525l2.138 2.138a.72.72 0 0 0 .525.225.72.72 0 0 0 .525-.225l4.238-4.238a.711.711 0 0 0 .206-.525.711.711 0 0 0-.207-.524.711.711 0 0 0-.524-.207.711.711 0 0 0-.526.207L6.95 9.35ZM8 15.5a7.3 7.3 0 0 1-2.925-.591 7.585 7.585 0 0 1-2.381-1.603 7.558 7.558 0 0 1-1.603-2.381A7.32 7.32 0 0 1 .5 8c0-1.037.197-2.012.591-2.925a7.591 7.591 0 0 1 1.603-2.381A7.563 7.563 0 0 1 5.075 1.09 7.306 7.306 0 0 1 8 .5c1.037 0 2.011.197 2.925.591a7.563 7.563 0 0 1 2.381 1.603 7.602 7.602 0 0 1 1.604 2.381A7.26 7.26 0 0 1 15.5 8a7.354 7.354 0 0 1-.591 2.925 7.524 7.524 0 0 1-1.603 2.381 7.619 7.619 0 0 1-2.381 1.604A7.266 7.266 0 0 1 8 15.5Z" /></svg>;

        const theme_data = () => {
            return (

                <div className="nxt-popup-content">
                    <div className="nxt-popup-title">
                        <span>{__('Get Free Theme Builder for', 'nexter-extension')}</span>
                        <span>{__('WordPress with Nexter Extension', 'nexter-extension')}</span>
                    </div>
                    <div className="nxt-features-dic">
                        <ul>
                            {[
                                __('Free WordPress Header & Footer Builder', 'nexter-extension'),
                                __('Free Single, Archive & 404 Page Builder', 'nexter-extension'),
                                __('Pre-Made Theme Builder Section Templates', 'nexter-extension'),
                                __('100% Customisable with Blocks', 'nexter-extension')
                            ].map((text, index) => (
                                <li key={index} className="nxt-feat-list">
                                    <span>{clickSvg}</span>
                                    <spna className="nxt-feat-list-acc-text">{text}</spna>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="nxt-popup-accordion">
                        {accordian_content.map((item, index) => (
                            <div key={index} className="nxt-accordion-item">
                                <div className={`nxt-accordio-content ${activeIndex === index ? "nxt-content-opan" : ""}`} onClick={() => theme_accordian(index)}>
                                    <div className="nxt-accd-qui">{item.question}</div>
                                    <div>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            {activeIndex !== index && (<path d="M10 4.16675V15.8334" stroke="black" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />)}
                                            <path d="M4.16797 10H15.8346" stroke="black" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </div>
                                </div>
                                <div className={`nxt-accd-ans ${activeIndex === index ? "opan-accordion" : ""}`} dangerouslySetInnerHTML={{ __html: item.answer }}></div>
                            </div>
                        ))}
                    </div>
                </div>

            );
        };

        const handleNxtExtension = (e) => {

            nxtInstallCall(e, true,"nexter-extension");

            setTimeout(() => {
                { !nxtext_ajax_object.pro ? setOnBoardingStep(onBoardingStep + 1) : setOnBoardingStep(onBoardingStep + 2) };

                setIsButtonDisabled(true);
            }, 1000);
        }

        return (
            <div className="nxt-board-enbltempl-cover nxt-board-onbsec-cover">
                <div className="nxt-board-pageimport-cover nxt-board-onbsec-cover">
                    <div className="nxt-board-page-crdgrid nxt-board-whitebg-cover">
                        {theme_data()}
                    </div>
                    <div className="nxt-board-btmsm-btn">
                        <a className="nxt-board-link-btn" onClick={() => { setOnBoardingStep(onBoardingStep - 1) }}>{__('Back', 'nexter-extension')}</a>
                        <div className="nxt-board-rit-btn-cover">
                            <span className="nxt-board-link-btn" onClick={() => { !nxtext_ajax_object.pro ? setOnBoardingStep(onBoardingStep + 1) : setOnBoardingStep(onBoardingStep + 2) }}>{__('Skip', 'nexter-extension')}</span>
                            <span className={`nxt_blue_common_btn ${(isButtonDisabled || nxtext_ajax_object.dashData.nexterext) ? 'nxt-board-none-element' : ''}`}
                                onClick={!isButtonDisabled ? handleNxtExtension : ''}>
                                {__('Enable Theme Builder', 'nexter-extension')}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const special_offer = () => {

        function copyCodeToClipboard(e) {
            const codeText = " FIRST20";
            const svgEl = e.currentTarget;
            const textWrapper = svgEl.closest('.nxt-board-uc-sndtxt');

            if (!textWrapper) return;
            const originalSVG = svgEl.outerHTML;

            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(codeText)
                    .then(() => showCopied())
                    .catch(() => fallbackCopy());
            } else {
                fallbackCopy();
            }

            function fallbackCopy() {
                const textarea = document.createElement('textarea');
                textarea.value = codeText;
                textarea.style.position = 'fixed';
                textarea.style.left = '-9999px';
                document.body.appendChild(textarea);
                textarea.focus();
                textarea.select();
                try {
                    document.execCommand('copy');
                    showCopied();
                } catch (err) {
                    console.error('Copy failed', err);
                }
                document.body.removeChild(textarea);
            }

            function showCopied() {
                textWrapper.childNodes[0].textContent = " Copied ";

                svgEl.outerHTML = `
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 14 14"><path fill="#14C38E" d="M6.95 9.35 5.338 7.738a.711.711 0 0 0-.526-.207.711.711 0 0 0-.525.207.711.711 0 0 0-.206.524c0 .213.069.388.206.525l2.138 2.138a.72.72 0 0 0 .525.225.72.72 0 0 0 .525-.225l4.238-4.238a.711.711 0 0 0 .206-.525.711.711 0 0 0-.207-.524.711.711 0 0 0-.524-.207.711.711 0 0 0-.526.207L6.95 9.35ZM8 15.5a7.3 7.3 0 0 1-2.925-.591 7.585 7.585 0 0 1-2.381-1.603 7.558 7.558 0 0 1-1.603-2.381A7.32 7.32 0 0 1 .5 8c0-1.037.197-2.012.591-2.925a7.591 7.591 0 0 1 1.603-2.381A7.563 7.563 0 0 1 5.075 1.09 7.306 7.306 0 0 1 8 .5c1.037 0 2.011.197 2.925.591a7.563 7.563 0 0 1 2.381 1.603 7.602 7.602 0 0 1 1.604 2.381A7.26 7.26 0 0 1 15.5 8a7.354 7.354 0 0 1-.591 2.925 7.524 7.524 0 0 1-1.603 2.381 7.619 7.619 0 0 1-2.381 1.604A7.266 7.266 0 0 1 8 15.5Z"/></svg>
                `;

                setTimeout(() => {
                    textWrapper.childNodes[0].textContent = codeText + " ";
                    textWrapper.querySelector('svg').outerHTML = originalSVG;

                    const newSvg = textWrapper.querySelector('svg');
                    if (newSvg) {
                        newSvg.addEventListener('click', copyCodeToClipboard);
                    }
                }, 1500);
            }
        }

        var plugin_url = nxtext_ajax_object.tpgb_url;

        let spoffer_widlist = [
            {
                img_url: plugin_url + 'assets/images/onboarding-frame-1.png',
                wid_name: __('Popup/Offcanvas Builder')
            },
            {
                img_url: plugin_url + 'assets/images/onboarding-frame-2.png',
                wid_name: __('Display Conditions')
            },
            {
                img_url: plugin_url + 'assets/images/onboarding-frame-3.png',
                wid_name: __('Mega Menus')
            },
            {
                img_url: plugin_url + 'assets/images/onboarding-frame-4.png',
                wid_name: __('Login/Registration Form')
            },
            {
                img_url: plugin_url + 'assets/images/onboarding-frame-5.png',
                wid_name: __('Dynamic Content')
            },
            {
                img_url: plugin_url + 'assets/images/onboarding-frame-6.png',
                wid_name: __('Custom Loop Skin')
            },
            {
                img_url: plugin_url + 'assets/images/onboarding-frame-7.png',
                wid_name: __('Posts/ CPT & Product Listing')
            },
            {
                img_url: plugin_url + 'assets/images/onboarding-frame-8.png',
                wid_name: __('Image & Video Gallery / Carousels')
            },


        ]

        const blueCheck = <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><path fill="#1717CC" d="M2.6 2.96c-2.949 2.98-2.933 7.804.048 10.753 2.98 2.949 7.804 2.933 10.753-.048 2.948-2.98 2.933-7.804-.048-10.753C10.373-.036 5.549-.02 2.6 2.96Zm9.102 3.894-4.134 4.183a.91.91 0 0 1-1.282 0l-.16-.16-.481-.481-1.346-1.33a.91.91 0 0 1 0-1.282.91.91 0 0 1 1.282 0l1.346 1.33 3.493-3.526a.91.91 0 0 1 1.282 0 .89.89 0 0 1 0 1.266Z" /></svg>;

        return (
            <div className="nxt-board-specof-cover">
                <div className="nxt-board-spctop-secs">
                    <div className="nxt-board-hbtn-list">
                        <div className="nxt-board-spof-hintxt">
                            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.1633 2.45227L7.55321 0.108488C7.41077 0.048985 7.16868 0 7.01441 0C6.85919 0 6.61848 0.048985 6.47502 0.108488L0.865186 2.45227C0.341867 2.66878 0 3.18148 0 3.72348C0 11.2851 5.52831 15 7.00973 15C8.50576 15 14.0253 11.2441 14.0253 3.72348C14.0253 3.18148 13.6834 2.66878 13.1633 2.45227ZM9.81771 5.85925C9.81771 6.02129 9.76217 6.18416 9.6488 6.31687L6.84374 9.59817C6.64741 9.82903 6.38736 9.81731 6.31139 9.81731C6.12602 9.81731 5.94702 9.74316 5.81553 9.61132L4.413 8.20505C4.2748 8.09463 4.20759 7.91299 4.20759 7.70791C4.20759 7.3332 4.50855 7.00477 4.90886 7.00477C5.08829 7.00477 5.26767 7.07345 5.40471 7.21076L6.27223 8.0806L8.58436 5.37529C8.72342 5.21322 8.9198 5.1303 9.11733 5.1303C9.65409 5.15612 9.81771 5.64245 9.81771 5.85925Z" fill="white" />
                            </svg>
                            <span className="nxt-board-smtxt">{__('60 days Money-Back Guarantee', 'nexter-extension')}</span>
                        </div>
                        <h2 className="nxt-board-onbrd-crd-h">{__('Get access to 90+ WordPress Blocks at FLAT 20% OFF', 'nexter-extension')}</h2>
                        <div className="nxt-board-use-code">
                            <div className="nxt-board-uc-l">{__('USE CODE:', 'nexter-extension')} <span className="nxt-board-uc-sndtxt">{__('FIRST20 ', 'nexter-extension')}
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 16 18" style={{ cursor: 'pointer' }} onClick={copyCodeToClipboard}><path fill="#1717CC" d="M9.934 18H3.219a2.816 2.816 0 0 1-2.813-2.813V5.66A2.816 2.816 0 0 1 3.22 2.848h6.715a2.816 2.816 0 0 1 2.812 2.812v9.527A2.816 2.816 0 0 1 9.934 18ZM3.219 4.254c-.776 0-1.406.63-1.406 1.406v9.527c0 .776.63 1.407 1.406 1.407h6.715c.775 0 1.406-.631 1.406-1.407V5.66c0-.775-.631-1.406-1.406-1.406H3.219Zm12.34 9.176V2.813A2.816 2.816 0 0 0 12.746 0H4.941a.703.703 0 1 0 0 1.406h7.805c.775 0 1.406.631 1.406 1.407V13.43a.703.703 0 1 0 1.407 0Z" /></svg> </span></div>
                        </div>
                        <div className="nxt-board-btmbtn-grp">
                            <a target="_blank" rel="noopener noreferrer" href="https://nexterwp.com/pricing/?utm_source=wpbackend&amp;utm_medium=blocks&amp;utm_campaign=nexterOnboarding" className="nxt_blue_common_btn">{__('Upgrade Now', 'nexter-extension')}</a>
                            <a target="_blank" rel="noopener noreferrer" href="https://nexterwp.com/wordpress-blocks/?utm_source=wpbackend&amp;utm_medium=blocks&amp;utm_campaign=nexterOnboarding" className="nxt-board-link-btn">{__('View all Block', 'nexter-extension')}</a>
                        </div>
                    </div>

                    <div className="nxt-board-ritsm-list">
                        <div className="nxt-board-chlist">
                            {blueCheck}
                            <span className="nxt-board-lismtxt">{__('Performance Optimized', 'nexter-extension')}</span>
                        </div>
                        <div className="nxt-board-chlist">
                            {blueCheck}
                            <span className="nxt-board-lismtxt">{__('90+ WordPress Blocks', 'nexter-extension')}</span>
                        </div>
                        <div className="nxt-board-chlist">
                            {blueCheck}
                            <span className="nxt-board-lismtxt">{__('100% Whitelabel Plugin', 'nexter-extension')}</span>
                        </div>
                    </div>
                </div>
                <div className="nxt-board-spwidlst-cover nxt-board-whitebg-cover">
                    {spoffer_widlist.map((data, index) => {
                        return (
                            <div key={index} className="nxt-board-spwid-crd">
                                <div className="nxt-board-spwidimg-cover">
                                    <img className="nxt-board-spwid-img" src={data.img_url} draggable={false} />
                                </div>
                                <span className="nxt-board-crd-btmh">{data.wid_name}</span>
                            </div>
                        )
                    })}
                </div>
                <div className="nxt-board-btmsm-btn">
                    <span className="nxt-board-link-btn" onClick={() => { setOnBoardingStep(onBoardingStep - 1) }}>{__('Back', 'nexter-extension')}</span>
                    <span className="nxt_blue_common_btn" onClick={() => { setOnBoardingStep(onBoardingStep + 1) }}>{__('Continue', 'nexter-extension')}</span>
                </div>
            </div>
        )
    }
    
    const stay_updated = () => {

        const handleSubscribe = async () => {

            const validateEmail = (email) => {
                const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                return regex.test(email);
            };

            if (!validateEmail(userEmail) || userEmail === '') {
                console.log('Invalid email address');
            }
            else {

                const encodedEmail = encodeURIComponent(userEmail);
                const welcomeEmailUrl = `https://store.posimyth.com/?fluentcrm=1&route=contact&hash=30275c78-0cf5-42f1-adb0-32901bb25b90&email=${encodedEmail}`;


                try {
                    const response = await fetch(welcomeEmailUrl, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Access-Control-Allow-Origin': 'http://localhost/',
                        },
                        mode: 'no-cors',
                    });


                } catch (error) {
                    console.error('Error during subscription:', error);
                }
            }

            setOnBoardingStep(onBoardingStep + 1)
        };

        return (

            <div className="nxt-board-stay-upcover nxt-board-onbsec-cover">

                <h2 className="nxt-board-onbrd-crd-h">{__('Get Exclusive WordPress Tips, Tricks and Resources Delivered Straight to Your Inbox!', 'nexter-extension')}</h2>

                <div className="nxt-board-whinf-cover nxt-board-whitebg-cover">
                    <div className="nxt-board-top-stxt">
                        <p className="nxt-board-sm-txt">{__('Join 500K+ Agency Owners, Marketers and WordPress Users.', 'nexter-extension')}</p>

                        <div className="nxt-board-grp-txtico">
                            <svg width="17" height="19" viewBox="0 0 17 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15.9552 2.9486L9.15521 0.130446C8.98255 0.0588995 8.68913 0 8.50212 0C8.31399 0 8.02223 0.0588995 7.84833 0.130446L1.04869 2.9486C0.414375 3.20893 0 3.8254 0 4.4771C0 13.5692 6.70083 18.036 8.49646 18.036C10.3098 18.036 17 13.5199 17 4.4771C17 3.8254 16.5856 3.20893 15.9552 2.9486ZM11.9 7.04515C11.9 7.23999 11.8327 7.43582 11.6953 7.5954L8.29526 11.5408C8.05729 11.8184 7.74208 11.8043 7.65 11.8043C7.42532 11.8043 7.20835 11.7152 7.04898 11.5566L5.34898 9.86574C5.18146 9.73297 5.1 9.51456 5.1 9.26797C5.1 8.81742 5.46479 8.42253 5.95 8.42253C6.16749 8.42253 6.38492 8.5051 6.55102 8.67021L7.60254 9.7161L10.4051 6.46324C10.5736 6.26836 10.8116 6.16867 11.0511 6.16867C11.7017 6.1997 11.9 6.78447 11.9 7.04515Z" fill="#1ECB2B" />
                            </svg>
                            <p className="nxt-board-icotxt">{__('NO SPAM GUARANTEE', 'nexter-extension')}</p>
                        </div>
                    </div>

                    <input className="nxt-board-in-boxfield" type="email" value={userEmail}  onChange={(e) => setUserEmail(e.target.value)} />

                    <div className="nxt-board-staywid-list" >
                        <input type="checkbox" id="nxt-board-agree-ch" className="nxt-board-chkbox-style" checked={isChecked} onChange={() => setIsChecked(!isChecked)} />
                        <label className="nxt-board-wid-chk-name" for="nxt-board-agree-ch">{__('Agree to contribute to make Nexter Blocks better by sharing non-sensitive details.', 'nexter-extension')}</label>
                    </div>
                </div>

                <div className="nxt-board-btmsm-btn">
                    <span className="nxt-board-link-btn" onClick={() => { !nxtext_ajax_object.pro ? setOnBoardingStep(onBoardingStep - 1) : setOnBoardingStep(onBoardingStep - 2) }}>{__('Back', 'nexter-extension')}</span>

                    <div className="nxt-board-rit-btn-cover">
                        <a className="nxt_blue_common_btn" onClick={handleSubscribe}>{__('Next', 'nexter-extension')}</a>
                    </div>
                </div>

            </div>
        )
    }

    const confirmation_all = () => {
        const site_url = nxtext_ajax_object.dashData.userData.siteUrl;

        const twitterShareText = `I just installed Nexter Blocks - @nexterwp It comes with 90+ WordPress Blocks, which replace multiple plugins for me, without compromising on my website performance. Excited to use it.\n\n${site_url}\n\n#WordPress`;

        const twitterShareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(twitterShareText)}`;

        const handleClick = () => {
            setLoading(true);
            data_save();

            setTimeout(() => {
                setLoading(false);
            }, 5000);
        };
        
        return (
            <div className="nxt-board-conf-allcover">
                <div className="nxt-board-setup-h">
                    <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.6064 4.87406C14.7141 3.81396 16.644 3.27365 19.1829 3.03428C19.744 2.97956 21.3248 2.99324 22.0229 3.05479C24.2675 3.25997 26.1562 3.80028 28.1819 4.79882C30.1049 5.74949 31.583 6.82326 33.0475 8.34159C34.382 9.7163 35.3332 11.0636 36.1818 12.7735C38.2964 17.0207 38.577 21.8766 36.9688 26.4042C36.6471 27.3139 35.8533 28.9553 35.3606 29.7282C34.0193 31.8347 32.1647 33.736 30.098 35.1175C29.1947 35.7194 27.4291 36.6085 26.4026 36.971C23.063 38.1542 19.6277 38.3183 16.206 37.4566C14.8989 37.1283 14.0709 36.8205 12.7843 36.1913C10.9434 35.2885 9.63636 34.3515 8.12397 32.8469C6.60474 31.3217 5.68089 30.0359 4.74335 28.1209C3.90846 26.4316 3.37467 24.6671 3.08725 22.6495C2.97092 21.8424 2.97092 19.1477 3.08725 18.3407C3.44995 15.8101 4.33959 13.2864 5.56455 11.3304C7.25486 8.622 9.82797 6.26244 12.6064 4.87406ZM22.0358 19.8617C24.7807 17.1026 27.1032 14.8198 27.1956 14.7801C27.4397 14.6809 27.9676 14.7404 28.1721 14.8926C28.5746 15.1904 28.733 15.6668 28.5878 16.1101C28.535 16.2755 27.0175 17.837 23.0256 21.8401C18.1495 26.7232 17.5029 27.3451 17.2786 27.3848C17.1609 27.4069 17.0683 27.4261 16.9763 27.4236C16.5989 27.4132 16.2317 27.0364 14.184 24.983C12.1313 22.9245 11.7587 22.5552 11.7502 22.1776C11.7481 22.0867 11.7671 21.9953 11.7889 21.8798C11.8483 21.5556 12.2442 21.1586 12.5675 21.099C13.1481 20.9865 13.1613 20.9932 15.1737 23.0046L17.0344 24.8705L22.0358 19.8617Z" fill="#14C38E" />
                    </svg>

                    <h2 className="nxt-board-onbrd-crd-h">{__('Setup Up Done Successfully.', 'nexter-extension')}</h2>
                </div>

                <div className="nxt-board-infcrd-cover">
                    <div className="nxt-board-smxtx-incover">
                        <p className="nxt-board-sm-intxt">
                            {__('I just Installed Nexter Blocks! It comes with 90+ WordPress Blocks which replace multiple plugins for me, without compromising on my website performance. Excited to use it.', 'nexter-extension')}
                        </p>
                    </div>

                    <div className="nxt-board-btn-grp">
                        <a href={twitterShareUrl} target="_blank" rel="noopener noreferrer" className="nxt_blue_common_btn">{__('Post on', 'nexter-extension')}
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clipPath="url(#clip0_659_32813)"><path d="M9.49 6.775 15.317 0h-1.382l-5.06 5.883L4.834 0H.172l6.112 8.895L.172 16h1.381l5.344-6.212L11.166 16h4.662l-6.34-9.225h.001zM7.597 8.974l-.62-.886L2.051 1.04h2.122L8.15 6.728l.618.886 5.17 7.393h-2.122L7.598 8.974z" fill="white" /></g><defs><clipPath id="clip0_659_32813"><rect width="16" height="16" fill="white" /></clipPath></defs></svg>
                        </a>
                    </div>
                </div>
                <div className="nxt-board-btmsm-btn">
                    <span className="nxt-board-link-btn" onClick={() => { setOnBoardingStep(onBoardingStep - 1) }}>{__('Back', 'nexter-extension')}</span>
                    <div className="nxt-board-rit-btn-cover">
                        <a className={`nxt_blue_common_btn ${loading ? 'loading' : ''}`} onClick={handleClick}>
                            <span className='button-text'>{__('Start Using', 'nexter-extension')}</span>
                            <span className="nxt-start-using-loader"></span>
                        </a>
                    </div>
                </div>
            </div>
        );

    };

    const handleOnboarding = () => {

        switch (onBoardingStep) {
            case 1: return select_mode();
            case 2: return select_blockCate();
            case 3: return <EnableTemplate onBoardingStep={onBoardingStep} setOnBoardingStep={setOnBoardingStep} reload={reload} />;
            case 4: return theme_builder();
            case 5: return (<>{!nxtext_ajax_object.pro &&
                special_offer()
            }
            </>);
            case 6: return stay_updated();
            case 7: return confirmation_all();
            default: return null;
        }
    }

     const closeOnboarding = () => {
        data_save();
    };

    return (
        <div className='nxt_dashboard_main_cover'>
            <span className="nxt_onboarding_close_btn"  onClick={closeOnboarding} >
                <span> { __( 'Skip Setup' , 'nexter-extension' ) } </span>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20"><path stroke="#666" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.667" d="M15 5 5 15M5 5l10 10" /></svg>
            </span>
            <div className="nxt-board-onboarding-cover">

                {/* ----------Steps Design Start---------- */}

                <div className="nxt-board-steps-cover-onbord">
                    {nav_array()?.map((data, index) => (
                        <div key={index} className="nxt-board-step-wrapper">
                            <div className={`nxt-board-step-box ${(data.step_number === onBoardingStep) ? 'nxt-board-step-active' : ''} ${(data.step_number < onBoardingStep) ? 'nxt-board-step-confirmed' : ''}`}
                                onClick={() => {
                                    if (data.step_number <= onBoardingStep) {
                                        setOnBoardingStep(data.step_number);
                                    }
                                }}
                            >
                                {/* Icon */}
                                {(data.step_number < onBoardingStep) ? (
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><path fill="#14C38E" d="M6.95 9.35 5.338 7.738a.711.711 0 0 0-.526-.207.711.711 0 0 0-.525.207.711.711 0 0 0-.206.524c0 .213.069.388.206.525l2.138 2.138a.72.72 0 0 0 .525.225.72.72 0 0 0 .525-.225l4.238-4.238a.711.711 0 0 0 .206-.525.711.711 0 0 0-.207-.524.711.711 0 0 0-.524-.207.711.711 0 0 0-.526.207L6.95 9.35ZM8 15.5a7.3 7.3 0 0 1-2.925-.591 7.585 7.585 0 0 1-2.381-1.603 7.558 7.558 0 0 1-1.603-2.381A7.32 7.32 0 0 1 .5 8c0-1.037.197-2.012.591-2.925a7.591 7.591 0 0 1 1.603-2.381A7.563 7.563 0 0 1 5.075 1.09 7.306 7.306 0 0 1 8 .5c1.037 0 2.011.197 2.925.591a7.563 7.563 0 0 1 2.381 1.603 7.602 7.602 0 0 1 1.604 2.381A7.26 7.26 0 0 1 15.5 8a7.354 7.354 0 0 1-.591 2.925 7.524 7.524 0 0 1-1.603 2.381 7.619 7.619 0 0 1-2.381 1.604A7.266 7.266 0 0 1 8 15.5Z" /></svg>
                                ) : (data.step_number === onBoardingStep) ? (
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><path fill="#1717CC" d="M6.95 9.35 5.338 7.738a.711.711 0 0 0-.526-.207.711.711 0 0 0-.525.207.711.711 0 0 0-.206.524c0 .213.069.388.206.525l2.138 2.138a.72.72 0 0 0 .525.225.72.72 0 0 0 .525-.225l4.238-4.238a.711.711 0 0 0 .206-.525.711.711 0 0 0-.207-.524.711.711 0 0 0-.524-.207.711.711 0 0 0-.526.207L6.95 9.35ZM8 15.5a7.3 7.3 0 0 1-2.925-.591 7.585 7.585 0 0 1-2.381-1.603 7.558 7.558 0 0 1-1.603-2.381A7.32 7.32 0 0 1 .5 8c0-1.037.197-2.012.591-2.925a7.591 7.591 0 0 1 1.603-2.381A7.563 7.563 0 0 1 5.075 1.09 7.306 7.306 0 0 1 8 .5c1.037 0 2.011.197 2.925.591a7.563 7.563 0 0 1 2.381 1.603 7.602 7.602 0 0 1 1.604 2.381A7.26 7.26 0 0 1 15.5 8a7.354 7.354 0 0 1-.591 2.925 7.524 7.524 0 0 1-1.603 2.381 7.619 7.619 0 0 1-2.381 1.604A7.266 7.266 0 0 1 8 15.5Z" /></svg>
                                ) : (
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><path fill="#D9D9D9" d="M6.95 9.35 5.338 7.738a.711.711 0 0 0-.526-.207.711.711 0 0 0-.525.207.711.711 0 0 0-.206.524c0 .213.069.388.206.525l2.138 2.138a.72.72 0 0 0 .525.225.72.72 0 0 0 .525-.225l4.238-4.238a.711.711 0 0 0 .206-.525.711.711 0 0 0-.207-.524.711.711 0 0 0-.524-.207.711.711 0 0 0-.526.207L6.95 9.35ZM8 15.5a7.3 7.3 0 0 1-2.925-.591 7.585 7.585 0 0 1-2.381-1.603 7.558 7.558 0 0 1-1.603-2.381A7.32 7.32 0 0 1 .5 8c0-1.037.197-2.012.591-2.925a7.591 7.591 0 0 1 1.603-2.381A7.563 7.563 0 0 1 5.075 1.09 7.306 7.306 0 0 1 8 .5c1.037 0 2.011.197 2.925.591a7.563 7.563 0 0 1 2.381 1.603 7.602 7.602 0 0 1 1.604 2.381A7.26 7.26 0 0 1 15.5 8a7.354 7.354 0 0 1-.591 2.925 7.524 7.524 0 0 1-1.603 2.381 7.619 7.619 0 0 1-2.381 1.604A7.266 7.266 0 0 1 8 15.5Z" /></svg>
                                )}
                                <div className="nxt-board-step-name">{data.step_name}</div>
                            </div>

                            {/* Chevron after each step except the last */}
                            {index !== nav_array().length - 1 && (
                                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" fill="none" viewBox="0 0 8 14"><path fill="#D9D9D9" d="M7.707 6.293a1 1 0 0 1 0 1.414L2.05 13.364A1 1 0 1 1 .636 11.95L5.586 7 .636 2.05A1 1 0 0 1 2.05.636l5.657 5.657Z" /></svg>
                            )}
                        </div>
                    ))}
                </div>

                {/* ----------Steps Design Completed---------- */}

                <div className="nxt-board-steps-tab-cover nxt-board-onbsec-cover">
                    {handleOnboarding()}
                </div>

            </div>
        </div>
    );
}
export default Onboarding;